export const ONE_IN_TEN_RATE = 0.1;
export const ONE_IN_THOUSAND_RATE = 0.001;

type SampleOptions = {
	/**
	 * The probability (between 0 and 1) that the callback will be executed.
	 * For example, a sampleRate of 0.001 means each call has a 0.1% (1 in 1000) chance to run the callback.
	 * Note: This is probabilistic sampling, so the callback is not guaranteed to run exactly 1 out of every 1000 calls,
	 * but will approach this ratio over a large number of calls.
	 */
	sampleRate?: number;
};

/**
 * Executes the provided callback function with a probability defined by `sampleRate`.
 * If `sampleRate` is not provided, defaults to ONE_IN_TEN_RATE (0.1).
 * Uses Math.random() to determine if the callback should be called.
 */
export function applySampling(callback: () => void, options: SampleOptions = {}) {
	if (Math.random() < (options.sampleRate ?? ONE_IN_TEN_RATE)) {
		callback();
	}
}

/**
 * Executes the callback with a 0.1% (1 in 1000) probability.
 */
export function applyOneInThousandSample(callback: () => void) {
	applySampling(callback, { sampleRate: ONE_IN_THOUSAND_RATE });
}
